import React from 'react'

import styled from 'styled-components'

import Select, { SelectOption } from 'components/Select'

import { color } from 'styles/colors'
import { scrubText } from 'helpers/inputCleaners'

export type Props = {
  isEditing: boolean
  options: Array<Array<SelectOption>>
  value?: string | number | null
  onChangeCallback: (value: string | number | null) => void
  autoFocus?: boolean
  className?: string
}

const DefaultOption: SelectOption = { value: '', name: 'CHOOSE ONE...' }

const ConfigDropdown = ({ isEditing, options, value, onChangeCallback, autoFocus = false, className }: Props) => {
  const optionsWithDefault = [[DefaultOption], ...options]

  const displayValue = (value) => {
    const option = options.reduce((a, b) => a.concat(b)).find(option => option.value === value)
    return option?.name || value || '--'
  }

  return (
    <>
      {isEditing ? <S.Select autoFocus={autoFocus} className={className} selectOptions={optionsWithDefault} onChange={(event) => onChangeCallback(scrubText(event.currentTarget.value, true))} value={value || ''} /> : displayValue(value)}
    </>
  )
}

export default ConfigDropdown

const S = {
  Select: styled(Select)`
    margin-right: 10px;
    margin-bottom: 0px;
    margin-top: 0px;

    > select:first-of-type {
      font-weight: 700;
      font-size: 0.85rem;
      text-overflow: ellipsis;
      text-transform: uppercase;
      border-radius: 4px;
      line-height: 1;
      height: 26px;
      margin: 0;
      padding-top: 0;
      padding-bottom: 0;
      color: ${color('editText')};
    }
  `
}
